import React from 'react';

import { initalPage, initalPageSize } from '../constants/table';

interface IProps<T> {
  items: T[];
  initialPage?: number;
  initialPageSize?: number;
}

interface IUsePaginationResult<T> {
  page: number;
  pageSize: number;
  currentItems: T[];
  totalCount: number;
  handlePageChange: (newPage: number) => void;
  handleRowsPerPageChange: (newRowsPerPage: number) => void;
}

const usePagination = <T>({
  items,
  initialPage = initalPageSize,
  initialPageSize = initalPage,
}: IProps<T>): IUsePaginationResult<T> => {
  const [page, setPage] = React.useState(initialPage);
  const [pageSize, setPageSize] = React.useState(initialPageSize);

  const handlePageChange = React.useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handleRowsPerPageChange = React.useCallback((newRowsPerPage: number) => {
    setPageSize(newRowsPerPage);
    setPage(1);
  }, []);

  const currentItems = React.useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return items.slice(startIndex, endIndex);
  }, [items, page, pageSize]);

  return {
    page,
    pageSize,
    currentItems,
    totalCount: items.length,
    handlePageChange,
    handleRowsPerPageChange,
  };
};

export default usePagination;
